import script from "./MedKitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedKitButton.vue?vue&type=script&setup=true&lang=ts"

import "./MedKitButton.vue?vue&type=style&index=0&id=98df5a26&lang=css"

const __exports__ = script;

export default __exports__